import { __rest, __assign } from 'tslib';
import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

var PolicyIcon = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(SvgIcon, __assign({}, props, { viewBox: "0 0 14 16" }),
        React.createElement("path", { d: "M6.211 9.95801L3.02698 6.77387C2.82508 6.57209 2.82508 6.24482 3.02698 6.04304L3.39221 5.67768C3.59411 5.4759 3.92126 5.4759 4.12317 5.67768L6.211 7.76563L12.5457 1.43095C12.6465 1.33007 12.6107 1.15354 12.4791 1.09827C10.3696 0.21183 8.39805 0 7 0C5.3275 0 2.83437 0.30201 0.26599 1.70112C0.10361 1.78958 0 1.96542 0 2.15033V9.70386C0 10.2844 0.27234 10.8339 0.74121 11.1993L6.69568 15.7665C6.8752 15.9042 7.12481 15.9042 7.30432 15.7665L13.2588 11.1993C13.7277 10.8339 14 10.2844 14 9.70386V2.65179C14 2.47361 13.7846 2.38438 13.6586 2.51037L6.211 9.95801Z" })));
};

export { PolicyIcon };
//# sourceMappingURL=PolicyIcon.esm.js.map
